import React from 'react';
import { Button } from '@material-ui/core';
import { CreateOrderButtonsDiv } from './layout/WrapperDiv';
import en from '../translationDefaults/en';
export const CreateOrderButtons = ({
  onCancelClick,
  onCreateDetailsClick
}) => /*#__PURE__*/React.createElement(CreateOrderButtonsDiv, null, /*#__PURE__*/React.createElement(Button, {
  title: "OK",
  size: "small",
  variant: "contained",
  color: "primary" // disabled={!orderVerified}
  ,
  onClick: onCreateDetailsClick
}, en.createDetails), /*#__PURE__*/React.createElement(Button, {
  title: "Cancel",
  size: "small",
  variant: "contained",
  color: "primary",
  onClick: onCancelClick
}, en.cancel));
export default CreateOrderButtons;